import React from "react";
import { CreateVariantsFromTemplateFormContext } from "./context";

export const useCreateVariantsFromTemplateFormContextProvider = () => {
  const context = React.useContext(CreateVariantsFromTemplateFormContext);
  return context;
};
